//var app_proposals_table_all = $('#app-proposals-table-all');

if ($('#app-buyer_agency-table').length) {
    var data_table_order = [0, "desc"];
    var app_buyer_agencies_table_all = $('#app-buyer_agency-table').DataTable({
        "processing": true,
        "serverSide": true,
        ajax: {
            url: '/buyer_agencies/index',
            dataSrc: 'data',
        },
        order: [0, "desc"],
        columns: [
            {data: 'id'},//0
            {data: 'name'},//1
            {data: 'main_email'},//2
            {data: 'main_phone'},//3
            {data: 'main_address'},//4
            {data: 'created_at_format'},//5
            // {data: 'assigned_to_name'},//6
            // {data: 'status'},//7
            // {data: 'approved_status'},//8
            // {data: 'integration'},//9
            {data: 'id'} //6
        ],
       // destroy: true,
        pageLength: user_entries,
        "columnDefs": [
            {
                "targets": 0,
                "visible": false,
                "orderable": false,
                "className": "text-center",
                // "createdCell": function (td, cellData, rowData, row, col) {
                //     var html = ' <div class="checkbox checkbox-danger buyer_agencies_check"> <input class="checkbox" class="form-control" type="checkbox"  id="' + rowData.id + '" name="selected_buyer_agencies[]" value="' + rowData.id + '" ><label for="' + rowData.id + '"> </label></div>';
                //     $(td).html(html);
                // }
            },
            {
                "targets": 1,
                "orderable": true,
                "visible": true,
            },
            {
                "targets": 2,
                "orderable": true,
            },
            {
                "targets": 3,
                "orderable": true,
            },
            {
                "targets": 4,
                "orderable": true,
            },
            {
                "targets": 5,
                "orderable": true,
            },
            {
                "targets": 6,
                "orderable": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                    console.log('rowData', rowData)
                    var html = '';
                    var auxHtml = '';
                    var html = '<div class="btn-group">\n' +
                        '            <button type="button" class="btn btn-outline btn-success waves-effect waves-light m-r-5 btn-off" data-toggle="dropdown">\n' +
                        '                <i class="fa fa-ellipsis-v"></i>\n' +
                        '                <span class="sr-only">Toggle Dropdown</span>\n' +
                        '            </button>\n' +
                        '            <ul class="dropdown-menu dropdown-menu-right">\n' +
                        '                             <li class="ms-hover">' + '<a class="contacts-buyer_agencies" href="javascript:void(0)" data-name="' + rowData.name + '" data-id="' + cellData + '" >' + '<i class="fa fa-list"></i> Contacts' + '</a>' + '</li>' +
                        '  </ul>\n' +
                       '  </div>';

                    $(td).html(html);
                }
            }
        ]
    });

    $('#pull_new_buyer_agency').on('click', function (){
        $('#new_buyer_code').val('')
        $('#new_b_agency_name').val('')
        $('#new_b_agency_address').val('')
        $('#new_b_agency_email').val('')
        $('#new_b_agency_phone').val('')
        $('#new_buyer_agency_info').hide()
        $('#new_b_agency_contact_list').html('')
        $('#save_new_buyer_agency').prop('disabled', false)
        $('#save_new_buyer_agency').hide()
        $('#new_buyer_agency_in').html('')
        $('#PullNewBuyerAgency').modal('show');
    })

    $('#removeBtn').on('click', function (){
        $('#new_buyer_code').val('')
        $('#new_b_agency_name').val('')
        $('#new_b_agency_address').val('')
        $('#new_b_agency_email').val('')
        $('#new_b_agency_phone').val('')
        $('#new_buyer_agency_info').hide()
        $('#new_b_agency_contact_list').html('')
        $('#save_new_buyer_agency').prop('disabled', false)
        $('#save_new_buyer_agency').hide()
        $('#new_buyer_agency_in').html('')
    })

    $('#search_new_agency').on('click', function (){
        var txt = $('#new_buyer_code').val()
        if(txt.trim() !== '') {
            show_overlay_loader($('#PullNewBuyerAgency'));
            $.ajax({
                type: 'GET',
                url: '/search-buyer-agency/' + txt,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    if(typeof data['error'] !== 'undefined')
                        global_notification('error', data['error'])
                    else {
                        $('#new_b_agency_name').val(data['agency']['name'])
                        if(data['contact']) {
                            $('#new_b_agency_address').val(data['contact']['address_line_1'] + ',' + data['contact']['address_line_2'] + ',' + data['contact']['city'] + ',' + data['contact']['region'] + ',' + data['contact']['postal_code'])
                            $('#new_b_agency_email').val(data['contact']['email'])
                            $('#new_b_agency_phone').val(data['contact']['phone'])
                        }
                        if(data['buyers'] && data['buyers'].length > 0) {
                            var html = ''
                            html += '<div class="col-sm-6" style="padding: 5px; color: white; background-color: #0e0e0e">'
                            html += '<b>Contact Name</b>'
                            html += '</div>'
                            html += '<div class="col-sm-6" style="padding: 5px; color: white; background-color: #0e0e0e">'
                            html += '<b>Contact Email</b>'
                            html += '</div>'
                            for (var i in data['buyers']) {
                                html += '<div class="col-sm-6" style="padding: 2px">'
                                html += data['buyers'][i]['name']
                                html += '</div>'
                                html += '<div class="col-sm-6" style="padding: 2px">'
                                html += data['buyers'][i]['email']
                                html += '</div>'
                            }
                            $('#new_b_agency_contact_list').html(html)
                        }
                        if(data['in'] > 0 ) {
                            $('#save_new_buyer_agency').prop('disabled', true)
                            $('#new_buyer_agency_in').html('Agency already integrated with your account!')
                        } else {
                            $('#save_new_buyer_agency').attr('data-id', data['agency']['id'])
                        }
                        $('#save_new_buyer_agency').show()
                        $('#new_buyer_agency_info').show()
                    }
                    hide_overlay_loader($('#PullNewBuyerAgency'));
                },
                error: function (xhr) {
                    ajax_error();
                    hide_overlay_loader($('#PullNewBuyerAgency'));;
                    debug(xhr.responseText);
                }
            });
        } else {
            global_notification('error', 'Please enter the code provided by the agency.')
        }
    })

    $('#save_new_buyer_agency').on('click', function (){
        swal({
                title: 'Warning',
                text: 'Do you want to continue saving the integration?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "Yes, continue",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    var agency_id = $('#save_new_buyer_agency').attr('data-id')
                    show_overlay_loader($('#PullNewBuyerAgency'));
                    $.ajax({
                        type: 'GET',
                        url: '/save-buyer-agency/' + agency_id,
                        dataType: 'json',
                        encode: true,
                        success: function (data) {
                            global_notification('success', 'Agency successfully integrated with your account ...');
                            $('#PullNewBuyerAgency').modal('hide');
                            hide_overlay_loader($('#PullNewBuyerAgency'));
                            $('#app-buyer_agency-table').DataTable().ajax.url('/buyer_agencies/index').load();
                        },
                        error: function (xhr) {
                            ajax_error();
                            hide_overlay_loader($('#PullNewBuyerAgency'));
                            debug(xhr.responseText);
                        }
                    })
                }
            }
        )
    })

    // document.getElementById('est_budget').addEventListener('input', function (e) {
    //     const value = e.target.value;
    //     if (!/^-?\d*(\.\d*)?$/.test(value)) {
    //         e.target.value = value.slice(0, -1); // remove last invalid character
    //     }
    // });

    // $('#adv_prod_category').select2({
    //
    // });
    // $('#adv_prod_subcategory').select2({
    //
    // });

    // $('#adv_category').on('change', function () {
    //     var category = $(this).val();
    //     console.log(category)
    //     $('#adv_subcategory').html('<option></option>');
    //     var html = '';
    //     if(typeof categories[parseInt(category)] !== 'undefined' && typeof categories[parseInt(category)].subcategories[0] !== 'undefined') {
    //         console.log(categories[parseInt(category)])
    //         for (var i in categories[parseInt(category)].subcategories)
    //             html += '<option value="' + categories[parseInt(category)].subcategories[i]['id'] + '">' + categories[parseInt(category)].subcategories[i]['name'] + '</option>'
    //     }
    //     $('#adv_subcategory').html(html);
    // })
    //
    // $('#adv_prod_category').on('change', function () {
    //     var category = $(this).val();
    //     console.log(category)
    //     $('#adv_prod_subcategory').html('<option></option>');
    //     var html = '';
    //     if(typeof prod_categories[parseInt(category)] !== 'undefined' && typeof prod_categories[parseInt(category)].subcategories[0] !== 'undefined') {
    //         console.log(prod_categories[parseInt(category)])
    //         for (var i in prod_categories[parseInt(category)].subcategories)
    //             html += '<option value="' + prod_categories[parseInt(category)].subcategories[i]['id'] + '">' + prod_categories[parseInt(category)].subcategories[i]['name'] + '</option>'
    //     }
    //     $('#adv_prod_subcategory').html(html);
    //     $('#adv_prod_subcategory').select2({
    //
    //     });
    // })

    $('#app-buyer_agency-table').on( 'length.dt', function ( e, settings, len ) {
        user_entries = len;
    });
    $('#app-buyer_agency-table').on( 'order.dt', function ( e, settings, len) {
        data_table_order = [len[0].col, ""+len[0].dir+""];
    });

    // $('#app-buyer_agency-table').on('click', '.request-buyer_agencies', function () {
    //     var agency_id = $(this).attr('data-id');
    //     show_loader();
    //     $.ajax({
    //         type: 'GET',
    //         url: '/request-approval/' + agency_id,
    //         dataType: 'json',
    //         encode: true,
    //         success: function (data) {
    //             global_notification('success', 'Agency request approval sent ...');
    //             $('#app-buyer_agency-table').DataTable().ajax.url('/buyer_agencies/index').load();
    //             hide_loader();
    //         },
    //         error: function (xhr) {
    //             ajax_error();
    //             hide_loader();
    //             debug(xhr.responseText);
    //         }
    //     });
    // })
    // $('#approve_buyer_agency_conf').on('click', function (){
    //     var agency_id = $(this).attr('data-id');
    //     var params = {
    //         id : agency_id,
    //         comments : $('#buyer_agency_approve_deny_comments').val(),
    //         action: 'approve',
    //     };
    //     approve_deny_buyer_agency(params)
    // });
    // $('#deny_buyer_agency_conf').on('click', function (){
    //     var agency_id = $(this).attr('data-id');
    //     var params = {
    //         id : agency_id,
    //         comments : $('#buyer_agency_approve_deny_comments').val(),
    //         action: 'deny',
    //     };
    //     approve_deny_buyer_agency(params)
    // });
    // function approve_deny_buyer_agency(params){
    //     show_overlay_loader($('#ApproveDenyBuyerAgencyModal'));
    //     $.ajax({
    //         type: 'POST',
    //         headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
    //         data: JSON.stringify(params),
    //         url: '/buyer_agency/approve_or_deny/new_business',
    //         dataType: "json",
    //         contentType: "application/json",
    //         success: function (data) {
    //             var text = params.action === 'deny' ? 'Rejected' : 'Approved';
    //             global_notification('success', 'Agency '+ text +' successfully ...');
    //             $('#app-buyer_agency-table').DataTable().ajax.url('/buyer_agencies/index').load();
    //             $('#ApproveDenyBuyerAgencyModal').modal('hide');
    //             hide_overlay_loader($('#ApproveDenyBuyerAgencyModal'));
    //         },
    //         error: function (xhr) {
    //             ajax_error();
    //             hide_loader();
    //             debug(xhr.responseText);
    //             hide_overlay_loader($('#ApproveDenyBuyerAgencyModal'));
    //         }
    //     });
    // }
    //
    // $('#app-buyer_agency-table').on('click', '.approve-buyer_agencies', function () {
    //     $('#approve_buyer_agency_conf').attr('data-id', $(this).attr('data-id'));
    //     $('#deny_buyer_agency_conf').attr('data-id', $(this).attr('data-id'));
    //     $('#ApproveDenyBuyerAgencyModal').modal('show');
    // })

    //Buyer Agency
    $('#select_all_buyer_agencies').on('click', function (e) {
        $('#app-buyer_agency-table input:checkbox').prop('checked', true);
    });
    $('#deselect_all_buyer_agencies').on('click', function (e) {
        $('#app-buyer_agency-table input:checkbox').prop('checked', false);
    });
    $('#delete_buyer_agencies').on('click', function () {
        var params = {ids: [],};
        $('.buyer_agencies_check input[type=checkbox]').each(function () {
            if (this.checked)
                params.ids.push($(this).val());
        });
        if (params.ids.length > 0) {
            swal({
                    title: 'Warning',
                    text: 'This operation will delete the selected Buyer Agencies. \n Do you want to continue?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Yes, continue",
                    cancelButtonText: "No",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        show_loader();
                        $.ajax({
                            type: 'POST',
                            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                            data: JSON.stringify(params),
                            url: '/buyer/agency/delete/multiple',
                            dataType: "json",
                            contentType: "application/json",
                            success: function (response) {
                                global_notification('success', 'Buyer Agencies deleted...');
                                $('#app-buyer_agency-table').DataTable().ajax.url('/buyer_agencies/index').load();
                                hide_loader();
                            },
                            error: function (xhr) {
                                hide_loader();
                                ajax_error();
                                debug(xhr.responseText);
                            }
                        });
                    }
                });
        } else
            global_notification('warning', 'Please select at least one Buyer Agency...');
    });
    $('#create_buyer_agency_modal').on('click', function () {
        $('#new_buyer_agency_name').val('');
        $('#new_buyer_agency_email').val('');
        $('#new_buyer_agency_address').val('');
        $('#new_buyer_agency_phone').val('');
        $('#save_buyer_agency').show();
        $('#update_buyer_agency').hide();

        $('#new_buyer_agency_user').html('');
        var  html = '';
        for(var ind in users_bellow_me)
            html += "<option value='"+ users_bellow_me[ind].id +"' >"+ users_bellow_me[ind].name +"</option>";
        $('#new_buyer_agency_user').html(html);

        $('#new_buyer_agency_status').html('');
        $('.new_buyer_agency_status_div').hide();

        $('#NewBuyerAgencyModal').modal('show');
    });
    $('#save_buyer_agency').on('click', function (){
        var params = {
            buyer_agency_name: $('#new_buyer_agency_name').val(),
            buyer_agency_email: $('#new_buyer_agency_email').val(),
            buyer_agency_address: $('#new_buyer_agency_address').val(),
            buyer_agency_phone: $('#new_buyer_agency_phone').val(),
            bookend_rule: $('#bookend_rule option:selected').val(),
            adv_category: $('#adv_category option:selected').val(),
            adv_subcategory: $('#adv_subcategory option:selected').val(),
            est_budget: $('#est_budget').val(),
            adv_website: $('#adv_website').val(),
            adv_exp_start: $('#adv_exp_start').val(),
            adv_exp_end: $('#adv_exp_end').val(),
            adv_keywords: $('#adv_keywords').val(),
            adv_prod_category: $('#adv_prod_category option:selected').val(),
            adv_prod_subcategory: $('#adv_prod_subcategory option:selected').val(),
            adv_cadence: $('#adv_cadence option:selected').val(),
            adv_forecast: $('#adv_forecast').val(),
            adv_lead_source: $('#adv_lead_source option:selected').val(),
            adv_next_action: $('#adv_next_action').val(),
            adv_ownership: $('#adv_ownership option:selected').val(),
            adv_advertisers: $('#adv_advertisers').val(),
        };
        global_match_existing = [];
        save_buyer_agency(params);
    });
    $('#create_buyer_agency_anyway').on('click', function (){
        var params = {
            buyer_agency_name: $('#new_buyer_agency_name').val(),
            buyer_agency_email: $('#new_buyer_agency_email').val(),
            buyer_agency_address: $('#new_buyer_agency_address').val(),
            buyer_agency_phone: $('#new_buyer_agency_phone').val(),
            bookend_rule: $('#bookend_rule option:selected').val(),
            comments: $('#buyer_agency_comments').val(),
            match_existing: false,
            global_match_existing: global_match_existing,
            adv_category: $('#adv_category option:selected').val(),
            adv_subcategory: $('#adv_subcategory option:selected').val(),
            est_budget: $('#est_budget').val(),
            adv_website: $('#adv_website').val(),
            adv_exp_start: $('#adv_exp_start').val(),
            adv_exp_end: $('#adv_exp_end').val(),
            adv_keywords: $('#adv_keywords').val(),
            adv_prod_category: $('#adv_prod_category option:selected').val(),
            adv_prod_subcategory: $('#adv_prod_subcategory option:selected').val(),
            adv_cadence: $('#adv_cadence option:selected').val(),
            adv_forecast: $('#adv_forecast').val(),
            adv_lead_source: $('#adv_lead_source option:selected').val(),
            adv_next_action: $('#adv_next_action').val(),
            adv_ownership: $('#adv_ownership option:selected').val(),
            adv_advertisers: $('#adv_advertisers').val(),
        };
        save_buyer_agency(params);
    });

    var global_match_existing = [];
     function save_buyer_agency(params){
         if($('#new_buyer_agency_name').val() !== '') {
             if(typeof params.match_existing === 'undefined')
                show_overlay_loader($('#NewBuyerAgencyModal'));
             else
                show_overlay_loader($('#matchingExistingBuyerAgency'));

             $.ajax({
                 type: 'POST',
                 headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                 data: JSON.stringify(params),
                 url: '/proposals/buyer_agency/add',
                 dataType: "json",
                 contentType: "application/json",
                 success: function (response) {
                     if(typeof response.match_exist !== 'undefined'){
                         global_match_existing = response.match_exist;
                         var html = '';
                         html += '<span style="margin-left: 5%;margin-top: 2%; font-weight: bold; color: darkred"> => ' + response.match_exist[0].name + '</span></br>';

                         $('.existingBuyerAgencyWarningModal_div').html('');
                         $('.existingBuyerAgencyWarningModal_div').html(html);

                         $('#buyer_agency_comments').html('');
                         $('#matchingExistingBuyerAgency').modal('show');

                     }
                     else if (response.exist === false) {
                         global_notification('success', 'Buyer Agency created...');
                         $('#app-buyer_agency-table').DataTable().ajax.url('/buyer_agencies/index').load();
                         $('#NewBuyerAgencyModal').modal('hide');
                     } else
                         global_notification('warning', 'Agency named ' + $('#new_buyer_agency_name').val() + ' already exist.');

                     if(typeof params.match_existing === 'undefined')
                         hide_overlay_loader($('#NewBuyerAgencyModal'));
                     else {
                         hide_overlay_loader($('#matchingExistingBuyerAgency'));
                         $('#matchingExistingBuyerAgency').modal('hide');
                     }
                 },
                 error: function (xhr) {
                     hide_overlay_loader($('#NewBuyerAgencyModal'));
                     hide_overlay_loader($('#matchingExistingBuyerAgency'));
                     ajax_error();
                     debug(xhr.responseText);
                 }
             });
         }else
             global_notification('warning', 'Agency name is required.');
     }
     var global_agency_updating = '';
    $('#app-buyer_agency-table').on('click', '.edit-buyer_agencies', function (){
        var agency_id = $(this).attr('data-id');
        show_loader();
        $.ajax({
            type: 'GET',
            url: '/buyer/agency/edit/' + agency_id,
            dataType: 'json',
            encode: true,
            success: function (response) {
                var data = response.agency;
                global_agency_updating = response.agency;
                $('#save_buyer_agency').hide();
                $('#update_buyer_agency').show();
                $('#update_buyer_agency').attr('data-id', agency_id);
                $('#new_buyer_agency_name').val(data.name);
                $('#new_buyer_agency_email').val(data.main_email);
                $('#new_buyer_agency_address').val(data.main_address);
                $('#new_buyer_agency_phone').val(data.main_phone);

                //Assigned to
                $('#new_buyer_agency_user').html('');
                $('#new_buyer_agency_status').html('');
                var html = '<option></option>';
                $('#update_buyer_agency').attr('user-assigned', '')
                for (var ind in response.users) {
                    var sel = parseInt(data.assigned_to) === parseInt(response.users[ind].id) ? 'selected' : '';
                    $('#update_buyer_agency').attr('user-assigned', sel);
                    html += "<option value='" + response.users[ind].id + "' " + sel + ">" + response.users[ind].name + "</option>";
                }
                $('#new_buyer_agency_user').html(html);

                //Approved Status
                var html = '<option></option>';
                if (data.status === 'Prospect' || data.status === 'Client') {
                    html += "<option value=' " + data.approved_status + " ' selected disabled>" + data.approved_status.toUpperCase() + "</option>";
                    $('#new_buyer_agency_status').html(html);
                    $('#new_buyer_agency_status').attr('disabled', true);

                } else {
                    var disabled = data.status === 'Lead' && (data.approved_status === 'pending' || data.approved_status === 'new business') && response.user_can_change_status === true ? false : true;
                    var sel = data.approved_status === 'new business' ? 'selected' : '';
                    html += "<option value='new business' " + sel + " " + disabled + ">New Business</option>";
                    var sel = data.approved_status === 'pending' ? 'selected' : '';
                    html += "<option value='pending' " + sel + " " + disabled + ">Pending</option>";
                    var sel = data.approved_status === 'approved' ? 'selected' : '';
                    html += "<option value='approved' " + sel + " " + disabled + ">Approved</option>";
                    var sel = data.approved_status === 'rejected' ? 'selected' : '';
                    html += "<option value='rejected' " + sel + " " + disabled + ">Rejected</option>";
                    $('#new_buyer_agency_status').html(html);
                    $('#new_buyer_agency_status').attr('disabled', disabled);
                }

                $('#adv_category ').val(data.category_id);
                $('#adv_subcategory ').val(data.subcategory_id);
                $('#est_budget').val(data.budget);
                $('#adv_website').val(data.website);
                var s = data.start_date !== null ? data.start_date.split(' ') : [];
                $('#adv_exp_start').val(s.length > 1 ? s[0] : '');
                s = data.end_date !== null ? data.end_date.split(' ') : [];
                $('#adv_exp_end').val(s.length > 1 ? s[0] : '');
                $('#adv_keywords').val(data.tags);
                $('#adv_budget_category ').val(data.budget_category);
                $('#adv_cadence ').val(data.cadence);
                $('#adv_forecast').val(data.forecast);
                $('#adv_lead_source ').val(data.lead_source);
                s = data.next_action !== null ? data.next_action.split(' ') : [];
                $('#adv_next_action').val(s.length > 1 ? s[0] : '');
                $('#adv_ownership ').val(data.ownership);
                $('#adv_advertisers').val(data.comp_advertisers);

                $('.new_buyer_agency_status_div').show();
                $('#NewBuyerAgencyModal').modal({backdrop: 'static', keyboard: false});
                $('#NewBuyerAgencyModal').modal('show');
                console.log('response ', response)
                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
                debug(xhr.responseText);
            }
        });

    });
    $('#update_buyer_agency').on('click', function (){
        if($('#new_buyer_agency_name').val() !== '' && $('#new_buyer_agency_user').val() !== '') {
            if(parseInt(global_agency_updating.assigned_to) ===  $('#new_buyer_agency_user').val() && global_agency_updating.approved_status ===  $('#new_buyer_agency_status').val())
                update_buyer_agency(0);
            else {
                var html = '';
                if(parseInt(global_agency_updating.assigned_to) !==  parseInt($('#new_buyer_agency_user').val())) {
                    var u = $('#new_buyer_agency_user option:selected').val() === '' ? 'No User' : $('#new_buyer_agency_user option:selected').html();
                    html += "This action will Reassign this Buyer Agency to <span style='font-weight: bold; '> " + u + "</span>";
                }
                if(global_agency_updating.approved_status !==  $('#new_buyer_agency_status').val()){
                    var u = $('#new_buyer_agency_status').val() ;
                    html += html == '' ? "This action will change this Buyer Agency Approval Status to <span style='font-weight: bold; '> " + u + "</span>" :
                        " and  it will change this Buyer Agency Approval Status to <span style='font-weight: bold;'> " + u + "</span>";
                }
                $('.reassign_div').html(html + ". Are you sure to continue?");
                $('#ReassignBuyerAgency').modal('show');
            }
        }else
            global_notification('warning', 'Agency name and Assigned to are required.');
    });
    $('#reassign_buyer_agency_conf').on('click', function (){
        update_buyer_agency(1);
    });
    function update_buyer_agency(from){
        if(from === 0)
          show_overlay_loader($('#NewBuyerAgencyModal'));
        else
          show_overlay_loader($('#ReassignBuyerAgency'));
        var params = {
            buyer_agency_id: $('#update_buyer_agency').attr('data-id'),
            buyer_agency_name: $('#new_buyer_agency_name').val(),
            buyer_agency_email: $('#new_buyer_agency_email').val(),
            buyer_agency_address: $('#new_buyer_agency_address').val(),
            buyer_agency_phone: $('#new_buyer_agency_phone').val(),
            bookend_rule: $('#bookend_rule option:selected').val(),
            buyer_agency_user: $('#new_buyer_agency_user option:selected').val(),
            reassign_comments: $('#buyer_agency_reassign_comments').val(),
            buyer_agency_status: $('#new_buyer_agency_status option:selected').val(),
            adv_category: $('#adv_category option:selected').val(),
            adv_subcategory: $('#adv_subcategory option:selected').val(),
            est_budget: $('#est_budget').val(),
            adv_website: $('#adv_website').val(),
            adv_exp_start: $('#adv_exp_start').val(),
            adv_exp_end: $('#adv_exp_end').val(),
            adv_keywords: $('#adv_keywords').val(),
            adv_prod_category: $('#adv_prod_category option:selected').val(),
            adv_prod_subcategory: $('#adv_prod_subcategory option:selected').val(),
            adv_cadence: $('#adv_cadence option:selected').val(),
            adv_forecast: $('#adv_forecast').val(),
            adv_lead_source: $('#adv_lead_source option:selected').val(),
            adv_next_action: $('#adv_next_action').val(),
            adv_ownership: $('#adv_ownership option:selected').val(),
            adv_advertisers: $('#adv_advertisers').val(),
        };
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: '/buyer_agency/update',
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                if (response.exist === false) {
                    global_notification('success', 'Buyer Agency updated...');
                    $('#app-buyer_agency-table').DataTable().ajax.url('/buyer_agencies/index').load();
                    $('#NewBuyerAgencyModal').modal('hide');
                } else
                    global_notification('warning', 'Agency named ' + $('#new_buyer_agency_name').val() + ' already exist.');
                if(from === 0)
                    hide_overlay_loader($('#NewBuyerAgencyModal'));
                else {
                    hide_overlay_loader($('#ReassignBuyerAgency'));
                    $('#ReassignBuyerAgency').modal('hide');
                }
            },
            error: function (xhr) {
                if(from === 0)
                    hide_overlay_loader($('#NewBuyerAgencyModal'));
                else
                    hide_overlay_loader($('#ReassignBuyerAgency'));
                ajax_error();
                debug(xhr.responseText);
            }
        });
    }
    var AgencyBuyerContactsColumnDef = [];
    var AgencyBuyerContactsGrid;
    $('#app-buyer_agency-table').on('click', '.contacts-buyer_agencies', function (){
        show_loader();
        var agency_id = $(this).attr('data-id');
        $('#add_buyer_agency_contact').val(agency_id);
        $('.BuyerAgencyContactsTitle').html('<i style="color: #e07a51; font-size: 20px;"></i><b>&nbsp;'+ $(this).attr('data-name') +' Contacts </b>')
        fill_BuyerAgencyContactsGrid(agency_id, true)
    });
    function fill_BuyerAgencyContactsGrid(agency_id, show){
        AgencyBuyerContactsColumnDef = [
            {
                field: 'name',
                headerName: "Name",
                width: 200,
                editable: true,
            },
            {
                field: 'role',
                headerName: "Role",
                width: 120,
                editable: true,
            },
            {
                field: 'email',
                headerName: "Email",
                width: 200,
                editable: true,
            },
            {
                field: 'phone',
                headerName: "Phone",
                width: 150,
                editable: true,
            },
            {
                field: 'address',
                headerName: "Address",
                width: 200,
                editable: true,
            },
            {
                field: 'edit',
                headerName: "",
                headerTitle: "Edit Contact",
                width: 50,
                cellStyle: {'text-align': "center"},
                cellRenderer: function (params) {
                    var html = '';
                    var value = params.data.id;
                    var name = params.data.name;
                    html += " <span style='margin-bottom: 20%'>" +
                        "<a style='background-color: white; color: dimgray; font-size: 13px'  class='edit_buyer_agency_contact' type='button' data-name='" + name + "' data-id='" + value + "'  href='#'>" +
                        "<i style='color: #1b6d85; font-weight: bolde…nt-weight: bolder; text-align: center; ' class='fa fa-pencil-square-o'></i></a>";
                    var tempDiv = document.createElement('div');
                    tempDiv.innerHTML = html;
                    this.eGui = tempDiv.firstElementChild;
                    return this.eGui;
                },
            },
            {
                field: 'delete',
                headerName: "",
                width: 50,
                cellStyle: {'text-align': "right"},
                cellRenderer: function (params) {
                    var html = '';
                    var value = params.data.id;
                    var name = params.data.name;
                    html += " <span style='margin-bottom: 20%'>" +
                        "<a style='background-color: white; color: dimgray; font-size: 13px'  class='delete_buyer_agency_contact' type='button'  data-name='" + name + "' data-id='" + value + "'  href='#'>" +
                        "<i style='color: #1b6d85; font-weight: bolde…nt-weight: bolder; text-align: center; ' class='fa fa-trash'></i></a>";

                    var tempDiv = document.createElement('div');
                    tempDiv.innerHTML = html;
                    this.eGui = tempDiv.firstElementChild;
                    return this.eGui;
                },
            },
        ];
        AgencyBuyerContactsGrid = {
            columnDefs: AgencyBuyerContactsColumnDef,
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
            rowSelection: 'single',
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 25,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            stopEditingWhenGridLosesFocus: true,
            suppressRowClickSelection: true,
            icons: {
                //  groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                //  groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
        };
        $.ajax({
            type: 'GET',
            url: '/buyer/agency/contacts/list/' + agency_id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                AgencyBuyerContactsGrid.rowData = [];
                AgencyBuyerContactsGrid.rowData = data;
                $('#buyerAgencyContactsListGridDiv').html("");
                var AgencyBuyerContactsGridGrid = document.querySelector('#buyerAgencyContactsListGridDiv');
                var g5 = new agGrid.Grid(AgencyBuyerContactsGridGrid, AgencyBuyerContactsGrid);
                if(show === true) {
                    $('#BuyerAgencyContactsListModal').modal({backdrop: 'static', keyboard: false})
                    $('#BuyerAgencyContactsListModal').modal('show');
                    hide_loader();
                }
                hide_overlay_loader($('#NewBuyerAgencyContactsModal'));
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
                hide_overlay_loader($('#NewBuyerAgencyContactsModal'));
                debug(xhr.responseText);
            }
        });
    }
    $('#add_buyer_agency_contact').on('click', function (){
        $('#save_buyer_contact').show();
        $('#update_buyer_contact').hide();
        $('#myModalLabelContact').html('New Contact');
        $('#buyer_contact_name_edit').val('');
        $('#buyer_contact_title_edit').val('');
        $('#buyer_contact_role_edit').val('');
        $('#buyer_contact_adress_line_1_edit').val('');
        $('#buyer_contact_adress_line_2_edit').val('');
        $('#buyer_contact_city_edit').val('');
        $('#buyer_contact_state_edit').val('');
        $('#buyer_contact_postal_edit').val('');
        $('#buyer_contact_nation_edit').val('');
        $('#buyer_contact_phone_edit').val('');
        $('#buyer_contact_cell_edit').val('');
        $('#buyer_contact_email_edit').val('');
        $('#buyer_contact_comment_edit').val('');
        $('#NewBuyerAgencyContactsModal').modal({backdrop: 'static', keyboard: false});
        $('#NewBuyerAgencyContactsModal').modal('show');
    });
    $('#save_buyer_contact').on('click', function (){
        if($('#buyer_contact_name_edit').val() !== '') {
            show_overlay_loader($('#NewBuyerAgencyContactsModal'));
            var params = {
                buyer_agency_id: $('#add_buyer_agency_contact').val(),
                buyer_contact_name: $('#buyer_contact_name_edit').val(),
                buyer_contact_title: $('#buyer_contact_title_edit').val(),
                buyer_role: $('#buyer_contact_role_edit option:selected').val(),
                buyer_address_line_1: $('#buyer_contact_adress_line_1_edit').val(),
                buyer_address_line_2: $('#buyer_contact_adress_line_2_edit').val(),
                buyer_address_city: $('#buyer_contact_city_edit').val(),
                buyer_address_region: $('#buyer_contact_state_edit').val(),
                buyer_address_postal_code: $('#buyer_contact_postal_edit').val(),
                buyer_address_nation: $('#buyer_contact_nation_edit').val(),
                buyer_phone: $('#buyer_contact_phone_edit').val(),
                buyer_fax: $('#buyer_contact_cell_edit').val(),
                buyer_email: $('#buyer_contact_email_edit').val(),
                buyer_comment: $('#buyer_contact_comment_edit').val(),
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: '/proposals/buyer_contact/add',
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    global_notification('success', 'Contacts created...');
                    fill_BuyerAgencyContactsGrid($('#add_buyer_agency_contact').val(), false)
                    $('#NewBuyerAgencyContactsModal').modal('hide');
                },
                error: function (xhr) {
                    hide_overlay_loader($('#NewBuyerAgencyContactsModal'));
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        }
        else
           global_notification('warning', 'Contact name is required.');
    });
    $('#buyerAgencyContactsListGridDiv').on('click', '.edit_buyer_agency_contact', function (){
        var contact_id = $(this).attr('data-id');
        show_overlay_loader($('#BuyerAgencyContactsListModal'));
        $.ajax({
            type: 'GET',
            url: '/buyer/agency/contact/edit/' + contact_id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                $('#save_buyer_contact').hide();
                $('#update_buyer_contact').show();
                $('#myModalLabelContact').html('Edit Contact');
                $('#update_buyer_contact').attr('data-id', contact_id);
                $('#buyer_contact_name_edit').val(data.contact_name);
                $('#buyer_contact_title_edit').val(data.contact_title);
                $('#buyer_contact_role_edit').val(data.role);
                $('#buyer_contact_adress_line_1_edit').val(data.address_line_1);
                $('#buyer_contact_adress_line_2_edit').val(data.address_line_2);
                $('#buyer_contact_city_edit').val(data.city);
                $('#buyer_contact_state_edit').val(data.region);
                $('#buyer_contact_postal_edit').val(data.postal_code);
                $('#buyer_contact_nation_edit').val(data.nation);
                $('#buyer_contact_phone_edit').val(data.phone);
                $('#buyer_contact_cell_edit').val(data.fax);
                $('#buyer_contact_email_edit').val(data.email);
                $('#buyer_contact_comment_edit').val(data.comment);

                $('#NewBuyerAgencyContactsModal').modal({backdrop: 'static', keyboard: false});
                $('#NewBuyerAgencyContactsModal').modal('show');
                hide_overlay_loader($('#BuyerAgencyContactsListModal'));
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
                debug(xhr.responseText);
                hide_overlay_loader($('#BuyerAgencyContactsListModal'));
            }
        });
    });
    $('#update_buyer_contact').on('click', function (){
        if($('#buyer_contact_name_edit').val() !== '') {
            show_overlay_loader($('#NewBuyerAgencyContactsModal'));
            var params = {
                id: $('#update_buyer_contact').attr('data-id'),
                buyer_contact_name: $('#buyer_contact_name_edit').val(),
                buyer_contact_title: $('#buyer_contact_title_edit').val(),
                buyer_role: $('#buyer_contact_role_edit option:selected').val(),
                buyer_address_line_1: $('#buyer_contact_adress_line_1_edit').val(),
                buyer_address_line_2: $('#buyer_contact_adress_line_2_edit').val(),
                buyer_address_city: $('#buyer_contact_city_edit').val(),
                buyer_address_region: $('#buyer_contact_state_edit').val(),
                buyer_address_postal_code: $('#buyer_contact_postal_edit').val(),
                buyer_address_nation: $('#buyer_contact_nation_edit').val(),
                buyer_phone: $('#buyer_contact_phone_edit').val(),
                buyer_fax: $('#buyer_contact_cell_edit').val(),
                buyer_email: $('#buyer_contact_email_edit').val(),
                buyer_comment: $('#buyer_contact_comment_edit').val(),
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: '/proposals/buyer_agency/contact/edit',
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    global_notification('success', 'Contacts created...');
                    fill_BuyerAgencyContactsGrid($('#add_buyer_agency_contact').val(), false)
                    $('#NewBuyerAgencyContactsModal').modal('hide');
                },
                error: function (xhr) {
                    hide_overlay_loader($('#NewBuyerAgencyContactsModal'));
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        }
        else
            global_notification('warning', 'Contact name is required.');
    });
    $('#buyerAgencyContactsListGridDiv').on('click', '.delete_buyer_agency_contact', function () {
        var contact_id = $(this).attr('data-id');
        swal({
                title: 'Warning',
                text: 'This operation will delete this Contact. \n Do you want to continue?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "Yes, delete",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    show_overlay_loader($('#BuyerAgencyContactsListModal'));
                    $.ajax({
                        type: 'GET',
                        url: '/buyer/agency/contact/delete/' + contact_id,
                        dataType: 'json',
                        encode: true,
                        success: function (data) {
                            fill_BuyerAgencyContactsGrid($('#add_buyer_agency_contact').val(), false)
                            hide_overlay_loader($('#BuyerAgencyContactsListModal'));
                        },
                        error: function (xhr) {
                            ajax_error();
                            hide_loader();
                            debug(xhr.responseText);
                            hide_overlay_loader($('#BuyerAgencyContactsListModal'));
                        }
                    });
                }
            });
    });
    $('#app-buyer_agency-table').on('click', '.delete-buyer_agencies' ,function () {
        var buyer_agency_id = $(this).attr('data-id');
        var buyer_agency_name = $(this).attr('data-name');
        swal({
                title: 'Warning',
                text: 'This operation will remove the Buyer Agency '+ buyer_agency_name +'. \n Do you want to continue?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "Yes, continue",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    show_loader();
                    $.ajax({
                        type: 'GET',
                        url: '/buyer/agency/delete/' + buyer_agency_id,
                        dataType: 'json',
                        encode: true,
                        success: function (response) {
                            global_notification('success', buyer_agency_name + 'has been deleted...');
                            $('#app-buyer_agency-table').DataTable().ajax.url('/buyer_agencies/index').load();
                            hide_loader();                          
                        },
                        error: function (xhr) {
                            ajax_error();
                            hide_loader();
                            debug(xhr.responseText);
                           
                        }
                    });
                }
            });
    });

    var BuyerAgencyIntegrationGrid;
    var BuyerAgencyIntegrationColumnDef = [];
    $('#agency_api_integration_agency_modal').on('click', function (){
        show_loader();
        $.ajax({
            type: 'GET',
            url: '/buyer/agency/api_integration/match',
            dataType: 'json',
            encode: true,
            success: function (response) {
                console.log('response ', response);
                BuyerAgencyIntegrationColumnDef = [
                    {
                        headerName: 'Buyer Agency',
                        field : "by_name",
                        width: 200,
                        hide: false,
                    },
                    {
                        headerName: 'Agency from External Software',
                        headerTooltip: 'Agency Name from External Software',
                        field: 'agencies_api_id',
                        headerClass: 'fixedHeaderCellClass',
                        minWidth: 50,
                        width: 400,
                        editable: true,
                        cellRenderer: MatchFormatRenderer,
                        cellEditor: SelectCellEditor,
                        cellEditorParams: {
                            values: response.agencies_api,
                        },
                    },
                ];
                BuyerAgencyIntegrationGrid = {
                    columnDefs: BuyerAgencyIntegrationColumnDef,
                    defaultColDef: {
                        width: 150,
                        suppressToolPanel: true
                    },
                    rowSelection: 'single',
                    enableColResize: true,
                    suppressTouch: true,
                    headerHeight: 25,
                    suppressDragLeaveHidesColumns: true,
                    enableCellChangeFlash: true,
                    rowHeight: 20,
                    suppressRowHoverClass: true,
                    suppressParentsInRowNodes: true,
                    toolPanelSuppressValues: true,
                    toolPanelSuppressRowGroups: true,
                    enableFilter: true,
                    enableSorting: true,
                    animateRows: true,
                    stopEditingWhenGridLosesFocus: true,
                    suppressRowClickSelection: true,
                    icons: {
                        //  groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                        //  groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                        menu: '<i class="fa fa-bars fa-lg"/>',
                        sortAscending: '<i class="fa fa-caret-down"/>',
                        sortDescending: '<i class="fa fa-caret-up"/>',
                        columnMoveMove: '<i class="fa fa-arrows"></i>',
                        columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                        columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                        columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                        columnMoveHide: '<i class="fa fa-remove"/>'
                    },
                };
                BuyerAgencyIntegrationGrid.rowData = [];
                BuyerAgencyIntegrationGrid.rowData = response.data;
                $('#matchByAgencyAPIGridDiv').html("");
                var BuyerAgencyIntegrationGridGrid = document.querySelector('#matchByAgencyAPIGridDiv');
                var g5 = new agGrid.Grid(BuyerAgencyIntegrationGridGrid, BuyerAgencyIntegrationGrid);
                $('#matchByAgencyAPIGridModal').modal({backdrop: 'static', keyboard: false})
                $('#matchByAgencyAPIGridModal').modal('show');
                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
                debug(xhr.responseText);
            }
        });
    });

    $('#match_buyer_agency_api').on('click', function (){
        show_overlay_loader($('#matchByAgencyAPIGridModal'));
        var params = { lines: [],};
        BuyerAgencyIntegrationGrid.api.forEachNode(function(node){
            params.lines.push(node.data);
        });
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: '/buyer/agency/api_integration/match/save',
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                global_notification('success', 'Buyer Software created...');
                hide_overlay_loader($('#matchByAgencyAPIGridModal'));
                $('#matchByAgencyAPIGridModal').modal('hide');
            },
            error: function (xhr) {
                hide_overlay_loader($('#matchByAgencyAPIGridModal'));
                ajax_error();
                debug(xhr.responseText);
            }
        });
    });

    //Buyer Software
    $('#create_buyer_software_modal').on('click', () => {
        $('#new_buyer_software_name').val('');
        $('#new_buyer_software_email').val('');
        $('#NewBuyerSoftware').modal('show');
    });
    $('#save_buyer_software').on('click', () =>{
        if($('#new_buyer_software_name').val() !== '' && $('#new_buyer_software_email').val() !== '') {
            show_overlay_loader($('#NewBuyerSoftware'));
            var params = {
                buyer_agency_name: $('#new_buyer_software_name').val(),
                buyer_agency_email: $('#new_buyer_software_email').val(),
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: '/buyers/software/add',
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    if (response.exist === false) {
                        global_notification('success', 'Buyer Software created...');
                        $('#BuyerSoftwareAccessTokenDiv').html(response.token);
                        $('#BuyerSoftwareToken').modal({backdrop: 'static', keyboard: false})
                        $('#BuyerSoftwareToken').modal('show');

                        var index = BuyerSoftwareGrid.api.getModel().rowsToDisplay.length;
                        BuyerSoftwareGrid.api.updateRowData({add: [{
                                id: response.software.id,
                                name: response.software.name,
                                email: response.software.email,
                            }], addIndex: index});

                        BuyerSoftwareGrid.api.ensureIndexVisible(index);
                        $('#NewBuyerSoftware').modal('hide');
                        hide_overlay_loader($('#NewBuyerSoftware'));
                    } else {
                        global_notification('warning', 'Buyer Software named ' + $('#new_buyer_software_name').val() + ' or Email ' + $('#new_buyer_software_name').val() + ' already exist.');
                        hide_overlay_loader($('#NewBuyerSoftware'));
                    }
                },
                error: function (xhr) {
                    hide_overlay_loader($('#NewBuyerSoftware'));
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        }else
            global_notification('warning', 'Agency Name and Email are required.');
    });
    $('#buyer_token_download').on('click', function(){
        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent($('#BuyerSoftwareAccessTokenDiv').val()));
        element.setAttribute('download', 'SpotAI API token');
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
    });
    $('#buyer_software_list_modal').on('click', function () {
        swal({
                title: 'Warning',
                text: 'This operation will generate a new Access Token for GaleforceMedia. \n Do you want to continue?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "Yes, continue",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    show_loader();
                    $.ajax({
                        type: 'GET',
                        url: '/buyer/software/generate_token/' ,
                        dataType: 'json',
                        encode: true,
                        success: function (response) {
                            global_notification('success', 'New Access Token generated for GaleforceMedia');
                            $('#BuyerSoftwareAccessTokenDiv').html(response.token);
                            $('#BuyerSoftwareToken').modal({backdrop: 'static', keyboard: false})
                            $('#BuyerSoftwareToken').modal('show');
                            hide_loader();
                        },
                        error: function (xhr) {
                            ajax_error();
                            hide_loader();
                            debug(xhr.responseText);
                            hide_loader();
                        }
                    });
                }
            });
    });
    $('#buyerSoftwareListGridDiv').on('click', '.delete_buyer_software' ,function () {
        var buyer_software_id = $(this).attr('data-id');
        var buyer_software_name = $(this).attr('data-name');
        swal({
                title: 'Warning',
                text: 'This operation will remove '+ buyer_software_name +' access to SpotAI. \n Do you want to continue?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "Yes, continue",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    show_overlay_loader('#BuyerSoftwareListModal');
                    $.ajax({
                        type: 'GET',
                        url: '/buyer/software/delete/' + buyer_software_id,
                        dataType: 'json',
                        encode: true,
                        success: function (response) {
                            global_notification('success', buyer_software_name + 'has been deleted...');
                            var nodesRemove = [];
                            BuyerSoftwareGrid.api.forEachNode(function(node){
                                if(parseInt(buyer_software_id) === parseInt(node.data.id))
                                    nodesRemove.push(node);
                            });
                            BuyerSoftwareGrid.api.removeItems(nodesRemove);
                            BuyerSoftwareGrid.api.refreshView();
                            hide_overlay_loader('#BuyerSoftwareListModal');
                        },
                        error: function (xhr) {
                            ajax_error();
                            hide_loader();
                            debug(xhr.responseText);
                            hide_overlay_loader('#BuyerSoftwareListModal');
                        }
                    });
                }
            });
    });
    function BuyerAgencyAPICellEditor() {
    }

    BuyerAgencyAPICellEditor.prototype.init = function (params) {
        this.eInput = document.createElement('input');
        var api_list = params.values;
        api_list.sort(function(a, b) {
            var textA = a.name +' ('+ a.software_name +')';
            var textB = b.name +' ('+ b.software_name +')';
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });

        console.log('this.params_this.params ',params);
         this.params = params;
        if (params.charPress !== null)
            this.eInput.value = params.charPress;
        else {
            if ((params.keyPress == 8) || (params.keyPress == 46))
                this.eInput.value = '';
            else {
                this.eInput.value = params.value;
                if (params.keyPress == null)
                    this.tabbed = true;
            }
        }
        var source = [];
        var vendor_cell_input = $(this.eInput);
        console.log('api_list ', api_list);
        for (var i in api_list) {
            var item = api_list[i];
            var label = item.name +' ('+ item.software_name +')';
            source.push({label: label, value: item['id']})
        }
        console.log('api_list source', source);

        $(vendor_cell_input).autocomplete({
            source: source,
            minLength: 0,
            messages: {
                noResults: '',
                results: function () {
                }
            }
        }).focus(function () {
            $(this).autocomplete("search");
        });
        if (typeof params.value !== 'undefined' && params.value !== "")
            this.eInput.value = params.value;

    };

    function SelectCellEditor() {
    }

    SelectCellEditor.prototype.init = function (params) {
        this.eInput = document.createElement('select');
        var vendor_cell_input = $(this.eInput);
        vendor_cell_input.addClass('form-control ws-custom-select');
        vendor_cell_input.append('<option value="0"></option>');
        for(var i in params.values)
            vendor_cell_input.append('<option value="' + params.values[i].id + '">' + params.values[i].name +' ('+ params.values[i].software_name +')' + '</option>');

        if (typeof params.value !== 'undefined')
            vendor_cell_input.val(params.value);
        else
            vendor_cell_input.val(0);
    };

    SelectCellEditor.prototype.getGui = function () {
        return this.eInput;

    };

    SelectCellEditor.prototype.afterGuiAttached = function () {
        this.eInput.focus();
    };

    SelectCellEditor.prototype.getValue = function () {
        return this.eInput.value;

    };

    SelectCellEditor.prototype.destroy = function () {

    };

    SelectCellEditor.prototype.isPopup = function () {
        return false;
    };

    function MatchFormatRenderer() {
    }

    MatchFormatRenderer.prototype.init = function (params) {
        this.eGui = document.createElement('div');
        if (params.value == 0)
            this.eGui.innerHTML = '';
        else {
            var api_string = '';
            var api_id = params.value;
            $.each(params.column.colDef.cellEditorParams.values, function (index, value) {
                if (value.id == api_id)
                    api_string = value.name + ' (' + value.software_name + ')';
            });
            this.eGui.innerHTML = api_string !== '' ? api_string : '';
        }
    };

    MatchFormatRenderer.prototype.getGui = function () {
        return this.eGui;
    };

    var VendorAPIColumnDef = [];
    var VendorAPIGrid;
    $('#vendor_list_modal').on('click', function (){
        show_loader();
        fill_vendors_list('new');
    });
    function fill_vendors_list(type){
        VendorAPIColumnDef = [
            {
                field: 'name',
                headerName: "Name",
                width: 200,
                editable: true,
                cellStyle: {'text-align': "left"},
            },
            {
                field: 'market',
                headerName: "Market",
                width: 320,
                editable: true,
                cellStyle: {'text-align': "left"},
            },
            {
                field: 'tp_id',
                headerName: "Vendor Trading ID",
                headerTitle: "Generate Token",
                width: 250,
                cellStyle: {'text-align': "left"},
            },
            {
                field: 'market_id',
                headerName: "Market ID",
                headerTitle: "market_id",
                width: 250,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
        ];
        VendorAPIGrid = {
            columnDefs: VendorAPIColumnDef,
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
            rowSelection: 'multiple',
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 25,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            stopEditingWhenGridLosesFocus: true,
            suppressRowClickSelection: true,
            icons: {
                //  groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                //  groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
        };
        $.ajax({
            type: 'GET',
            url: '/vendors/trading_id/api/list',
            dataType: 'json',
            encode: true,
            success: function (data) {
                console.log('data_data ', data)
                VendorAPIGrid.rowData = [];
                VendorAPIGrid.rowData = data;
                $('#vendorTradingIDListDiv').html("");
                var VendorAPIGridGrid = document.querySelector('#vendorTradingIDListDiv');
                var g5 = new agGrid.Grid(VendorAPIGridGrid, VendorAPIGrid);
                if(type === 'new'){
                    $('#vendorTradingIDListModal').modal({backdrop: 'static', keyboard: false})
                    $('#vendorTradingIDListModal').modal('show');
                    hide_loader();
                }else{
                    global_notification('success', 'Trading ID generated...');
                    hide_overlay_loader($('#vendorTradingIDListModal'));
                }
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
                debug(xhr.responseText);
            }
        });
    }
    $('#generate_vendor_trading_id').on('click', function () {
      swal({
              title: 'Warning',
              text: 'This operation will only affect vendors without a Trading ID. \n Do you want to continue?',
              type: 'warning',
              showCancelButton: true,
              confirmButtonClass: "btn-danger",
              confirmButtonText: "Yes, continue",
              cancelButtonText: "No",
              closeOnConfirm: true,
              closeOnCancel: true
          },
          function (isConfirm) {
              if (isConfirm) {
                  show_overlay_loader($('#vendorTradingIDListModal'));
                  $.ajax({
                      type: 'GET',
                      url: '/vendors/trading_id/api/generate',
                      dataType: 'json',
                      encode: true,
                      success: function (response) {
                          fill_vendors_list('update');
                      },
                      error: function (xhr) {
                          hide_overlay_loader($('#vendorTradingIDListModal'));
                          ajax_error();
                          debug(xhr.responseText);
                      }
                  });
              }
          });
    });
    $('#download_vendor_trading_id').on('click', function () {
        var columns_to_export = ['name', 'tp_id', 'vendor_type','market', 'market_id'];
        VendorAPIGrid.api.forEachNode(function (node) {
            if(node.data.tp_id !== '')
                node.setSelected(true);
        });
        var params = {
            skipHeader: false,
            columnGroups: true,
            skipFooters: false,
            skipGroups: false,
            skipPinnedTop: false,
            skipPinnedBottom: false,
            allColumns: false,
            columnKeys: columns_to_export,
            onlySelected: true,
            suppressQuotes: false,
            fileName: "vendors_trading_id_list.xls" ,
        };
        params.processCellCallback = function (params) {
            console.log('params_params ', params)
            if(params.node.data.tp_id !== '')
                return params.value;
        };
        console.log('params_params_final ', params)
        var content = VendorAPIGrid.api.getDataAsExcel(params);
        var workbook = XLSX.read(content, {type: 'binary'});
        var xlsxContent = XLSX.writeFile(workbook, 'vendors_trading_id_list.xlsx', {bookType: 'xlsx', type: 'base64'});
        VendorAPIGrid.api.forEachNode(function (node) {
            node.setSelected(false);
        });
    });

    //Proposals Forcast
    var completeProposalColumnDef = [
        {
            field: 'reference_number',
            headerName: "REFERENCE #",
            width: 200,
            editable: false
        },
        {
            field: 'proposal_id',
            headerName: "Proposal Id",
            width: 200,
            hide: true
        },
        {
            field: 'forecast',
            headerName: "How likely to order (%)",
            width: 200,
            cellRenderer: params => `${params.value}%`,
            editable: true
        },
        {
            field: 'description',
            headerName: "Comments",
            width: 300,
            editable: true,
            cellEditor: 'agTextCellEditor',
        },
    ];
    var completeProposalGRID = {
        columnDefs: completeProposalColumnDef,
        defaultColDef: {
            width: 150,
            suppressToolPanel: true
        },
        rowSelection: 'single',
        enableColResize: true,
        suppressTouch: true,
        headerHeight: 25,
        suppressDragLeaveHidesColumns: true,
        stopEditingWhenGridLosesFocus: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
    };
    $('#app-buyer_agency-table').on('click', '.proposal-forcast', function (){
        var agency_id = $(this).attr('data-id');
        show_loader();
        $.ajax({
            type: 'GET',
            url: '/buyer/agency/proposal/forescast/edit/' + agency_id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                if(data.data.length > 0) {
                   // $('.agency_name_span').html(data.agency.name)
                    $('.agency_name_span').html('<i style="color: #e07a51; font-size: 20px;"></i><b>&nbsp; Proposal Forecast </b> ('+ data.agency.name + ')')
                    completeProposalGRID.rowData = [];
                    completeProposalGRID.rowData = data.data;
                    $('#proposalCompForm').html("");
                    var compProposalGridGrid = document.querySelector('#proposalCompForm');
                    var g5 = new agGrid.Grid(compProposalGridGrid, completeProposalGRID);
                    $('#CompleteSentProposal').modal('show');
                }
                else
                    global_notification('warning', 'This Buyer Agency has no pending proposals...')
                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
                debug(xhr.responseText);
            }
        });
    });

    $('#proposal_finish_process').on('click', function (){
        show_overlay_loader("#proposalCompForm");
        var params = {
            data: completeProposalGRID.rowData
        }
        $.ajax({
            type: 'POST',
            url: '/proposals/forecast/update',
            data: JSON.stringify(params),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            traditional: true,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                global_notification('success', "Proposals forecast updated ...");
                $("#CompleteSentProposal").modal('hide');
                hide_overlay_loader("#proposalCompForm");
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
                hide_overlay_loader("#proposalCompForm");
            }
        });
    })

    //Activities Feature
    var gridActivitiesColumnDef = [
        {
            headerName: "Title",
            field: 'title',
            width: 200,
            cellStyle: {'text-align': "left"},
            cellClassRules : {
                'ag-cell-color-cna': function (params) {
                    if (typeof params.node.data.type !== 'undefined' && params.node.data.type === 'CNA')
                        return true;
                    else
                        return false;
                },
                'ag-cell-color-presentation': function (params) {
                    if (typeof params.node.data.type !== 'undefined' && params.node.data.type === 'Presentation')
                        return true;
                    else
                        return false;
                },
                'ag-cell-color-cold_call': function (params) {
                    if (typeof params.node.data.type !== 'undefined' && params.node.data.type === 'Cold Call Outreach')
                        return true;
                    else
                        return false;
                },
                'ag-cell-color-follow-up': function (params) {
                    if (typeof params.node.data.type !== 'undefined' && params.node.data.type === 'Follow-up Presentation')
                        return true;
                    else
                        return false;
                },
                'ag-cell-color-email': function (params) {
                    if (typeof params.node.data.type !== 'undefined' && params.node.data.type === 'Email')
                        return true;
                    else
                        return false;
                },
                'ag-cell-color-phone': function (params) {
                    if (typeof params.node.data.type !== 'undefined' && params.node.data.type === 'Phone')
                        return true;
                    else
                        return false;
                },
                'ag-cell-color-meeting': function (params) {
                    if (typeof params.node.data.type !== 'undefined' && params.node.data.type === 'Meeting')
                        return true;
                    else
                        return false;
                },
                'ag-cell-color-notes': function (params) {
                    if (typeof params.node.data.type !== 'undefined' && params.node.data.type === 'Notes')
                        return true;
                    else
                        return false;
                },
            },
            cellRenderer: function (params) {
                var icons = {
                    'CNA': '📋',
                    'Presentation': '📽️',
                    'Cold Call Outreach': '📞',
                    'Follow-up Presentation': '🔁',
                    'Email': '✉️',
                    'Phone': '📱',
                    'Meeting': '👥',
                    'Notes': '📝'
                };
                var type = params.node.data.type;
                var icon = icons[type] || '📌';
                var html = '';
                html += "<span class='grid_row_title_cell' style='cursor: pointer' data-id ='"+ params.node.data.id +"'> " +  icon +' '+ params.value + "  </span> ";
                var tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;
                this.eGui = tempDiv.firstElementChild;
                return this.eGui;
            }

        }, {
            headerName: "Buyer Agency",
            field: 'company_name',
            width: 200,
            cellStyle: {'text-align': "left"},
            hide: true,
        },
        {
            headerName: "Date",
            field: 'date',
            width: 100,
            cellStyle: {'text-align': "left"},
        },
        {
            headerName: "Start Time",
            field: 'start_time',
            width: 100,
            cellStyle: {'text-align': "left"},
        },
        {
            headerName: "End Time",
            field: 'end_time',
            width: 100,
            cellStyle: {'text-align': "left"},
        },
        {
            headerName: "All Day",
            field: 'allDay',
            width: 80,
            cellStyle: {'text-align': "left"},
            cellRenderer: function (params) {
                var text = params.value === false ? 'No' : "Yes";
                var html = " <span> " + text + "  </span> ";
                var tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;
                this.eGui = tempDiv.firstElementChild;
                return this.eGui;
            }
        },
        {
            headerName: "Location",
            field: 'location',
            width: 150,
            cellStyle: {'text-align': "left"},
        },{
            headerName: "Type",
            field: 'type',
            width: 120,
            cellStyle: {'text-align': "left"},
        },{
            headerName: "Activity For",
            field: 'activityFor_name',
            width: 120,
            cellStyle: {'text-align': "left"},
        },
        {
            headerName: "Description",
            field: 'description',
            width: 250,
            cellStyle: {'text-align': "left"},
        },
    ];
    var gridActivities = {
        columnDefs: gridActivitiesColumnDef,
        defaultColDef: {
            suppressToolPanel: true,
            resizable: true
        },
        rowSelection: 'single',
        suppressRowClickSelection: true,
        enableColResize: true,
        suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 25,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 25,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 3,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        getContextMenuItems : getContextMenuItemsOrderLine,
        onGridReady: function (e) {

        },
    };
    function getContextMenuItemsOrderLine(params){
        var result = ['separator',]
        return result;
    }
    $('#app-buyer_agency-table').on('click', '.see-activities', function (){
        var agency_id = $(this).attr('data-id');
        var agency_name = $(this).attr('data-name');
        show_loader();
        $.ajax({
            type: 'GET',
            url: '/buyer/agencies/get-activities/logs/' + agency_id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                $('.BuyerAgencyActivityTitle').html(agency_name + ' Activities');
                $('#buyerAgencyActivityListGridDiv').html('');
                gridActivities.rowData = [];
                gridActivities.rowData = data;

                $('#buyerAgencyActivityListGridDiv').html("");
                var gridActivitiesD = document.querySelector('#buyerAgencyActivityListGridDiv');
                var g5 = new agGrid.Grid(gridActivitiesD, gridActivities);
                $('#BuyerAgencyActivitiesModal').modal('show');

                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
                debug(xhr.responseText);
            }
        });
    });
    $('.export_calendar_grid').on('click', 'a',function (){
        if($(this).attr('data-column') === 'csv' || $(this).attr('data-column') === 'no-style') {
            var style = $(this).attr('data-column') === 'csv' ? 'csv' : 'xls';
            var params = {
                skipHeader: false,
                columnGroups: false,//(format == "csv") ? false : true,
                skipFooters: false,
                skipGroups: false,
                skipPinnedTop: false,
                skipPinnedBottom: false,
                allColumns: false,
                onlySelected: false,
                suppressQuotes: false,
                //fileName: "Events.csv",
            };
            if(style === 'csv') {
                params.customHeader = [
                    [
                        "Events ( " + date_range + ")" + "\n"
                    ],
                ];
            }else{
                params.customHeader = [
                    [
                        {data: {type: 'String', value: 'Events '}},
                    ],
                    [],

                ];
            }

            if(style === 'csv')
                gridActivities.api.exportDataAsCsv(params);
            else
                gridActivities .api.exportDataAsExcel(params);
        }
    });

    $('.export_calendar_grid_excel').on('click', function (){
        const columnApi = gridActivities.api.getColumnApi ? gridActivities.api.getColumnApi() : gridActivities.columnApi;
        const headers = columnApi.getAllDisplayedColumns().map(col => col.getColDef().headerName);
        const columns = columnApi.getAllDisplayedColumns().map(col => col.colId);
        var typeColors = {
            'CNA': '#f4d4d1',
            'Presentation': '#e7a39e',
            'Cold Call Outreach': '#f9e0dc',
            'Follow-up Presentation': '#ece9f1',
            'Email': '#f0f2f3',
            'Phone': '#dff1f0',
            'Meeting': '#f8e4e4',
            'Notes': '#fceceb',
        };
        let tableHtml = '<table><thead><tr><td colspan="'+ headers.length +'"> <b>Events </b></td></tr></table>';
        tableHtml += '<table><thead><tr><td colspan="'+ headers.length +'"> </td></tr></table>';
        tableHtml += '<table><thead><tr>';

        headers.forEach(header => {
            tableHtml += '<th style="color: white; background-color: #8E2215">'+ header.toUpperCase() +'</th>';
        });
        tableHtml += '</tr></thead><tbody>';

        var ind = 0;
        gridActivities.api.forEachNode(function(node){
            var back_color = ind % 2 === 0 ? "#F6F6F6" : '#FFFFFFF';
            ind++;
            tableHtml += '<tr>';
            for(var i in columns) {
                var col = columns[i];
                if(col === 'title') {
                    const color = typeof typeColors[node.data.type] !== 'undefined' ? typeColors[node.data.type] : 'white';
                    tableHtml += '<td style="background-color: '+ color +' "> ' + node.data[col] + '</td>';
                }else
                    tableHtml += '<td style="background-color: '+ back_color +' " >' + node.data[col]+'</td>';
            }
            tableHtml += '</tr>';
        });

        tableHtml += '</tbody></table>';

        var a = document.createElement('a');
        var data_type = 'data:application/vnd.ms-excel';
        a.href = data_type + ', ' + encodeURIComponent(tableHtml);
        a.download = 'Events ' + '.xls';
        a.click();
        if (typeof e !== 'undefined')
            e.preventDefault();

        return false;

        var params = {
            skipHeader: false,
            columnGroups: false,//(format == "csv") ? false : true,
            skipFooters: false,
            skipGroups: false,
            skipPinnedTop: false,
            skipPinnedBottom: false,
            allColumns: false,
            onlySelected: false,
            suppressQuotes: false,
            fileName: "Events.csv",
        };

        params.customHeader = [
            [
                "Events" +"\n"
            ],
        ];

        gridActivities.api.exportDataAsCsv(params);

    });

    //CNA Forms
    var gridCNATemplatesColumnDef = [
        {
            headerName: "Name",
            field: 'title',
            width: 200,
            cellStyle: {'text-align': "left"},
        },
        {
            headerName: "Created By",
            field: 'created_by',
            width: 120,
            cellStyle: {'text-align': "left"},
        },
        {
            headerName: "Created At",
            field: 'created_at',
            width: 140,
            cellStyle: {'text-align': "left"},
        },
        {
            headerName: "Descrption",
            field: 'description',
            width: 300,
            cellStyle: {'text-align': "left"},
        },
        {
            field: 'see',
            headerName: "",
            width: 50,
            cellStyle: {'text-align': "right"},
            cellRenderer: function (params) {
                var html = '';
                var value = params.data.see;
                html += " <span style='margin-bottom: 20%'>" +
                    "<a style='background-color: white; color: dimgray; font-size: 13px' title='Click to create a CNA form using this template' class='see_cna_template' type='button' data-id='" + value + "'  href='#'>" +
                    "<i style='color: darkred; font-weight: bolde…nt-weight: bolder; text-align: center; ' class='fa fa-plus-square'></i></a>";

                var tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;
                this.eGui = tempDiv.firstElementChild;
                return this.eGui;
            },
        },
        {
            field: 'download',
            headerName: "",
            width: 50,
            cellStyle: {'text-align': "right"},
            cellRenderer: function (params) {
                var html = '';
                var value = params.data.see;
                html += " <span style='margin-bottom: 20%'>" +
                    "<a style='background-color: white; color: dimgray; font-size: 13px' title='Click to export this Template to PDF' class='download_cna_template' type='button' data-id='" + value + "'  href='#'>" +
                    "<i style='color: #1b6d85; font-weight: bolde…nt-weight: bolder; text-align: center; ' class='fa fa-file-pdf-o'></i></a>";

                var tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;
                this.eGui = tempDiv.firstElementChild;
                return this.eGui;
            },
        },
    ];
    var gridCNATemplates = {
        columnDefs: gridCNATemplatesColumnDef,
        defaultColDef: {
            suppressToolPanel: true,
            resizable: true
        },
        rowSelection: 'single',
        suppressRowClickSelection: true,
        enableColResize: true,
        suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 25,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 25,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 3,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
       // getContextMenuItems : getContextMenuItemsOrderLine,
    };

    $('#app-buyer_agency-table').on('click', '.see-cna_form', function (){
        var agency_id = $(this).attr('data-id');
        var agency_name = $(this).attr('data-name');
        $('#save_cna_form_for_by').val(agency_id);
        $('#save_cna_form_for_by').attr('data-agency-name', agency_name);
        show_loader();
        $.ajax({
            type: 'GET',
            url: '/cna/get-lead-form/buyer_agency/' + agency_id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                $('.existing_cna_form_div').html('No CNA Form is currently associated with this Buyer Agency. Please use a template to create one.');
                $('.BuyerAgencyCNATitle').html(agency_name + ' CNA Form');
                gridCNATemplates.rowData = [];
                gridCNATemplates.rowData = data.template;
                $('#cnaFormTemplateListGridDiv').html('');
                var gridCNATemplatesD = document.querySelector('#cnaFormTemplateListGridDiv');
                var g5 = new agGrid.Grid(gridCNATemplatesD, gridCNATemplates);
                $('#CNAFormTemplateModal').modal('show')
               hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
                debug(xhr.responseText);
            }
        });
    });

    var hidden_fields_gl = [];
    var oldValueSelected = '';
    var last_index_array = {};
    var questions_names_gl = {};
    var template_selected_id = '';
    $('#cnaFormTemplateListGridDiv').on('click', '.see_cna_template', function () {
        var template_id = $(this).attr('data-id');
        hidden_fields_gl = [];
        last_index_array = {};
        questions_names_gl = {};
        show_loader();
        $.ajax({
            type: 'GET',
            url: '/cna/template/see_form/' + template_id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                template_selected_id = template_id;
                load_form('create', data);
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
                debug(xhr.responseText);
            }
        });
    });

    $('#app-buyer_agency-table').on('click', '.edit-cna_form', function () {
        var form_id = $(this).attr('data-id');
        var agency_name = $(this).attr('data-name');
        $('#update_cna_form_for_by').val(form_id);
        $('#update_cna_form_for_by').attr('data-agency-name', agency_name);
        hidden_fields_gl = [];
        last_index_array = {};
        questions_names_gl = {};
        show_loader();
        $.ajax({
            type: 'GET',
            url: '/cna/lead/edit/' + form_id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                load_form('udpate', data);
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
                debug(xhr.responseText);
            }
        });
    });

    function load_form(from, data){
        $('.div_to_show_form').html('');
        $('.div_to_show_form').html(data.html);
        hidden_fields_gl = data.hidden_class;
        last_index_array = data.index_by_tab;
        questions_names_gl = data.questions_names;
        for (var ind in data.select2_fields){
            var input = data.select2_fields[ind];

            var isMultiple = $("#CNAFormModal .div_to_show_form  #" + input).prop('multiple');
            if(isMultiple === true) {
                $("#CNAFormModal .div_to_show_form  #" + input).select2({
                    minimumResultsForSearch: 100,
                    placeholder: 'Select at least one....',
                }).on('select2:select', function (e) {
                    let selectedValue = e.params.data.id;
                    var selectedOption = e.params.data.element;
                    var dataId = $(selectedOption).data('id');
                    var div_index = $(this).attr('data-tab') + '_' + $(this).attr('data-ind') + '_' + dataId;
                    if (hidden_fields_gl.indexOf(div_index) !== -1)
                        $("#CNAFormModal .div_to_show_form ." + div_index).show();
                }).on('select2:unselect', function (e) {
                    let selectedValue = e.params.data.id;
                    var selectedOption = e.params.data.element;
                    var dataId = $(selectedOption).data('id');
                    var div_index = $(this).attr('data-tab') + '_' + $(this).attr('data-ind') + '_' + dataId;
                    if (hidden_fields_gl.indexOf(div_index) !== -1)
                        $("#CNAFormModal .div_to_show_form  ." + div_index).hide();

                });
            }else{
                $("#CNAFormModal .div_to_show_form  #" + input).select2({
                    minimumResultsForSearch: 100,
                    placeholder: 'Select one....',
                }).on('select2:opening', function () {
                    oldValueSelected = $(this).find('option:selected').attr('data-id'); // Store current value before change
                }).on('change', function (e) {
                    const selectedOption = $(this).find('option:selected');
                    const dataId = selectedOption.attr('data-id'); // gets the value of data-id
                    const selectedValue = selectedOption.val();

                    const div_index = $(this).attr('data-tab') + '_' + $(this).attr('data-ind') + '_' + dataId;
                    const class_index = $(this).attr('data-tab') + '_' + $(this).attr('data-ind') + '_' + oldValueSelected;

                    $("#CNAFormModal .div_to_show_form ."+ class_index).hide();
                    console.log('hidden_fields_gl ', hidden_fields_gl)
                    console.log('hide ', class_index)
                    console.log('show ', div_index)

                    if (hidden_fields_gl.indexOf(div_index) !== -1) {
                        $("#CNAFormModal .div_to_show_form ." + div_index).show();
                    }
                })
            }
        }
        if(from == 'create'){
            $('.save_cna_form_for_by').show();
            $('.update_cna_form_for_by').hide();
        }else{
            $('.save_cna_form_for_by').hide();
            $('.update_cna_form_for_by').show();
        }
        $('#CNAFormModal').modal({backdrop: 'static', keyboard: false});
        $('#CNAFormModal').modal('show')
        hide_loader();
    }

    $('#cnaFormTemplateListGridDiv').on('click', '.download_cna_template', function () {
        var link = document.createElement('a');
        var id = $(this).attr('data-id');
        link.href = "/cna/form/" + id + '/download';
        $(link).attr('target', '_blank');
        link.click();
    });

    $('.save_cna_form_for_by').on('click', function (){
        show_overlay_loader($('#CNAFormModal'));
        $('#agency_id_cna').val($('#save_cna_form_for_by').val());
        $('#template_selected_id_cna').val(template_selected_id);
        var agency_name = $('#save_cna_form_for_by').attr('data-agency-name');
        $('#last_index_array').val(JSON.stringify(last_index_array));
        $('#questions_names_gl').val(JSON.stringify(questions_names_gl));
        var data = $('#cna_dynamic_form_ba').serializeArray();
        var button_id = $(this).attr('id');
        $.ajax({
            type: 'POST',
            url: '/lead_cna/store',
            data: data,
            dataType: 'json',
            encode: true,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                global_notification('success', 'CNA Form created for this  Buyer Agency...');
                $('#app-buyer_agency-table').DataTable().ajax.url('/buyer_agencies/index').load();
                if(button_id === 'save_and_show_cna_form_for_by'){
                    var id = data.id;
                    var link = document.createElement('a');
                    link.href = "/lead/cna_form/" + id + '/download';
                    $(link).attr('target', '_blank');
                    link.click();
                }
                $('#CNAFormModal').modal('hide');
                $('#CNAFormTemplateModal').modal('hide');
                hide_overlay_loader($('#CNAFormModal'));
            },
            error: function (xhr) {
                debug(xhr.responseText);
                ajax_error();
                hide_overlay_loader($('#CNAFormModal'));
            }
        });

    });

    $('.update_cna_form_for_by').on('click', function (){
        show_overlay_loader($('#CNAFormModal'));
        $('#agency_id_cna').val($('#update_cna_form_for_by').val());
        var agency_name = $('#update_cna_form_for_by').attr('data-agency-name');
        $('#last_index_array').val(JSON.stringify(last_index_array));
        $('#questions_names_gl').val(JSON.stringify(questions_names_gl));
        var data = $('#cna_dynamic_form_ba').serializeArray();
        var button_id = $(this).attr('id');
        $.ajax({
            type: 'POST',
            url: '/lead_cna/update',
            data: data,
            dataType: 'json',
            encode: true,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                global_notification('success', 'CNA Form updated ...');
                $('#app-buyer_agency-table').DataTable().ajax.url('/buyer_agencies/index').load();
                if(button_id === 'update_and_show_cna_form_for_by'){
                    var id = data.id;
                    var link = document.createElement('a');
                    link.href = "/lead/cna_form/" + id + '/download';
                    $(link).attr('target', '_blank');
                    link.click();
                }
                $('#CNAFormModal').modal('hide');
                $('#CNAFormCreateModal').modal('hide');
                hide_overlay_loader($('#CNAFormModal'));
            },
            error: function (xhr) {
                debug(xhr.responseText);
                ajax_error();
                hide_overlay_loader($('#CNAFormModal'));
            }
        });

    });

    $('#app-buyer_agency-table').on('click', '.download-cna_form' ,function (){
        var id = $(this).attr('data-id');
        var link = document.createElement('a');
        link.href = "/lead/cna_form/" + id + '/download';
        $(link).attr('target', '_blank');
        link.click();
    });

   $('#app-buyer_agency-table').on('click', '.send-cna_form' ,function (){
        var id = $(this).attr('data-id');
       show_loader();
       $.ajax({
           type: 'GET',
           url: '/cna/lead/send_by_email/' + id,
           dataType: 'json',
           encode: true,
           success: function (data) {
               $('#send_cna_form_email').val(id);
               $('.manager_email').html('');
               $('.manager_email').html(data.html);
               if(data.manager !== null && data.manager.email != '' && data.manager.email != null)
                   $('#send_cna_form_email').show();
               else
                   $('#send_cna_form_email').hide();

               $('#CNASendByEmailModal').modal('show');

               hide_loader();
           },
           error: function (xhr) {
               ajax_error();
               hide_loader();
               debug(xhr.responseText);
           }
       });

   });
   $('#send_cna_form_email').on('click', function (){
       var params = {
           lead_id: $(this).val(),
           copy: $("input:checkbox[name=send_me_copy]:checked").attr('value'),
       }
       show_overlay_loader($('#CNASendByEmailModal'));
       $.ajax({
           type: 'POST',
           headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
           data: JSON.stringify(params),
           url: '/cna/lead/send/manager_email',
           dataType: "json",
           contentType: "application/json",
           success: function (data) {
               var error_show = false;
               if (typeof data['errorEmails'] !== undefined && data['errorEmails'] !== null && typeof data['errorEmails'][0] !== 'undefined')
                   error_show = data['errorEmails'][0].indexOf('@fmbcmail.com') !== - 1 || data['errorEmails'][0].indexOf('@sbgtv.com') !== -1 ? false : true;
               if ( typeof data['errorEmails'] !== undefined && data['errorEmails'] !== null && error_show === true)
                   global_notification('error', 'The following contacts did not receive the CNA Form: (' + data['errorEmails'].join() + '). Please check their email addresses and re-send.', 35000);
               else {
                   global_notification('success', 'Email sent succefully ...');
                   $('#CNASendByEmailModal').modal('hide');
               }

               hide_overlay_loader($('#CNASendByEmailModal'));
           },
           error: function (xhr) {
               ajax_error();
               hide_loader();
               debug(xhr.responseText);
               hide_overlay_loader($('#CNASendByEmailModal'));
           }
       });
   });

}
